// extracted by mini-css-extract-plugin
export default {"modelArticleTab":"Mz_4pbfjGU","tabActive":"frcQPBlp7q"};